import {useToast} from 'vue-toastification'
import {Modal} from 'bootstrap'
import useApi from "@/composables/useApi";

export default function useDataCenter() {
    const toast = useToast()
    const MODAL_ID = 'modalId'
    const {fetchResource, createResource, updateResource, deleteResource, uploadFile} = useApi()

    const baseStructure = {
        short_name: '',
        title: '',
        category: '',
        unit: '',
        min_allowed: 0,
        max_allowed: 0,
        evaluation_period: 'ماهانه',
        higher_period_calculation: 'جمع مقادیر',
        description: null,
        responsible: null,
        data_provider: null
    }

    const getModal = () => Modal.getOrCreateInstance(document.getElementById(MODAL_ID))

    const data = () => ({
        items: [],
        newItem: structuredClone(baseStructure),
        editedItem: null,
        editIndex: null,
        selectedFile: null,
        tableHeaders: ['نام کوتاه', 'عنوان', 'دسته بندی', 'واحد سنجش', 'دوره ارزیابی'],
        tableFields: ['short_name', 'title', 'category', 'unit', 'evaluation_period'],
    })

    const methods = {
        validateItem(item) {
            const requiredFields = [
                'short_name',
                'title',
                'category',
                'unit',
                'evaluation_period'
            ]

            const missingFields = requiredFields.filter(field => !item[field])

            if (missingFields.length > 0) {
                toast.error('فیلدهای اجباری را پر کنید!')
                return false
            }

            return true
        },

        async fetchData() {
            const response = await fetchResource('/v2/finance-and-productivity/data-center')
            this.items = response.data
        },

        async addItem() {
            if (!this.validateItem(this.newItem)) return

            const payload = {
                ...this.newItem,
                min_allowed: Number(this.newItem.min_allowed),
                max_allowed: Number(this.newItem.max_allowed)
            }

            const response = await createResource('/v2/finance-and-productivity/data-center', payload)

            this.items.unshift(response.data)
            Object.assign(this.newItem, baseStructure)
        },

        async removeItem(index) {
            const deletedItem = this.items.find((_, i) => i === index)
            await deleteResource(`/v2/finance-and-productivity/data-center/${deletedItem.id}`)
            this.items = this.items.filter((_, i) => i !== index)
        },

        async startEditing(item, index) {
            this.editedItem = structuredClone(item)
            this.editIndex = index
        },

        async editItem() {
            if (!this.validateItem(this.editedItem) || this.editIndex === null) throw new Error()

            const payload = {
                ...this.editedItem,
                min_allowed: Number(this.editedItem.min_allowed),
                max_allowed: Number(this.editedItem.max_allowed)
            }

            const response = await updateResource(`/v2/finance-and-productivity/data-center/${this.editedItem.id}`, payload)

            this.items.splice(this.editIndex, 1, response.data)
            this.editIndex = null
            this.editedItem = null
        },

        async openEditModal(item, index) {
            await this.startEditing(item, index)
            getModal().show()
        },

        async handleUpdate() {
            try {
                await this.editItem()
                getModal().hide()
            } catch (error) {
                toast.error('خطا در ذخیره تغییرات')
            }
        },

        async uploadExcel(file) {
            if (!file) {
                toast.error('لطفا یک فایل انتخاب کنید');
                return;
            }

            if (!['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'].includes(file.type)) {
                toast.error('فرمت فایل باید اکسل باشد (xls یا xlsx)');
                return;
            }

            const formData = new FormData();
            formData.append('file', file);
            console.log(formData)

            try {
                const response = await uploadFile('/v2/finance-and-productivity/data-center/upload', formData);
                toast.success('فایل با موفقیت آپلود شد');
                await this.fetchData();
                return response;
            } catch (error) {
                if (error.errors) {
                    error.errors.forEach(err => toast.error(err));
                }
                throw error;
            }
        }
    }

    return {
        data, methods,
    }
}